import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'markup', 'animationContainer']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "markup")[]
 * }>} RichTextBlockStyles
 */
export const richTextBlockStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.RichTextBlock} args.component - RichTextBlock component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {RichTextBlockStyles} - Component styles
   */
  baseStyle: ({
    component: {alignment = 'left', animation, quote, image},
  }) => {
    return {
      root: {
        textAlign: alignment,
      },
      markup: {
      },
      animationContainer: {
        sx: {
          // h1 => headingXL (target all descendant spans)
          'h1 span, .h1 span': {
            fontSize: {base: '2rem', lg: '2.5rem'},
            fontWeight: 500,
            lineHeight: 1.2,
            fontFamily: 'heading',
          },
          // h2 => headingL
          'h2 span, .h2 span': {
            fontSize: {base: '1.5rem', lg: '2rem'},
            fontWeight: 500,
            lineHeight: {base: 1.5, lg: 1.4},
            fontFamily: 'heading',
          },
          // h3 => labelXL
          'h3 span, .h3 span': {
            fontSize: {base: '1.25rem', lg: '1.5rem'},
            fontWeight: 500,
            lineHeight: {base: 1.5, lg: 1.4},
            fontFamily: 'body',
          },
          // h4 => labelL
          'h4 span, .h4 span': {
            fontSize: {base: '1rem', lg: '1.125rem'},
            fontWeight: 500,
            lineHeight: 1.6,
            fontFamily: 'body',
          },
          // h5 => labelDefault
          'h5 span, .h5 span': {
            fontSize: {base: '0.875rem', lg: '1rem'},
            fontWeight: 600,
            lineHeight: 1.4,
            fontFamily: 'body',
          },
          // h6 => labelS
          'h6 span, .h6 span': {
            fontSize: {base: '0.8125rem', lg: '0.75rem'},
            fontWeight: 600,
            lineHeight: 1.2,
            fontFamily: 'body',
          },
          // p => bodyDefault
          'p span': {
            fontSize: {base: '0.875rem', lg: '1rem'},
            fontWeight: 400,
            lineHeight: 1.4,
            fontFamily: 'body',
          },
        }
      },
    };
  },
});
